/**
 *
 * Activation
 *
 */
import React, { memo } from "react";
import { Footer } from "app/components/AdminLayout/Footer";
import { Activate } from "./components/activate";

interface Props {}

export const Activation = memo((props: Props) => {
  return (
    <React.Fragment>
      <main className="overflow-hidden">
        <Activate />
      </main>
      <Footer />
    </React.Fragment>
  );
});
